import { Injectable } from '@angular/core';
import { Shared } from '../models/shared';
import { HttpClientWrapper } from './httpclientwrapper';
import { Observable } from 'rxjs';
import { Jobapplication } from '../models/jobapplication';
import { JobSource } from '@apply4u/features/jobs/enums/job-source.enum';
import { LocalstorageService } from './localstorage.service';
import { ContextService } from './context-service';
import { Job } from '@apply4u/models/search/job';
import { IsAny, IsNotNull, IsNotNullOrEmpty, IsNotZero, IsNull, IsZero } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { JobApplyNowUrlPipe } from '@apply4u/shared/pipes/job-apply-now-url.pipe';
import { CvDistributionStatus } from '@apply4u/features/jobs/enums/cv-distribution-status.enum';
import { LoginTypeKeys } from '@apply4u/shared/constant/Local-storage-keys/login-type-keys';
import { LoadingService } from './loading.service';
import { JobApplicationStatus } from '@apply4u/features/jobs/enums/job-application-status.enum';
import { Applynow } from '@apply4u/shared/constant/applynow';
import { ToasterMessageService } from './toaster-message.service';
import { ProfileService } from '@apply4u/services/profile.service';
import { error } from 'console';
import { Jobsource } from '@apply4u/models/jobsource';

@Injectable({
  providedIn: 'root'
})
export class JobapplicationService {
  baseUrl: string = Shared.baseUrl;
  JobSource = JobSource;
  IsCvDistributed: boolean = false;
  CvDistributionStatusId: number;
  QuickApplyJobId: number = 0;

  constructor(private http: HttpClientWrapper,
    private localStorageService: LocalstorageService,
    private loadingSerive: LoadingService,
    private toasterService: ToasterMessageService,
    public ContextService: ContextService,
    private profileService: ProfileService) {
    this.GetQuickApplyJobId();
    this.GetCvDistributionStatus();
  }

  PostJobApplication(application: any): Observable<any> {
    return this.http.PostAsync<any>(this.baseUrl + "api/Jobs/applications", application);
  }

  DirectJobApplication(application: any): Observable<any> {
    return this.http.PostAsync<any>(this.baseUrl + "api/Jobs/applications/talent", application);
  }

  GetJobApplications(userId: number, jobId: number, cvSuitablityTypeId: number, candidateSelfSuitableTypeId: number
    , cvFeedbackTypeId: number, resumeId: number, coveringLetter: string, appliedOn: Date, isViewedByRecruiter: number,
    recruiterViewedOn: Date, candidateSelfNotes: string, employerSelfNotes: string, consultantNotes: string, isDeleted: number): Observable<any> {
    var searchQuery = this.CreateQueryParamsForJobApplication(userId, jobId, cvSuitablityTypeId, candidateSelfSuitableTypeId, cvFeedbackTypeId,
      resumeId, coveringLetter, appliedOn, isViewedByRecruiter, recruiterViewedOn, candidateSelfNotes, employerSelfNotes, consultantNotes, isDeleted);

    return this.http.GetAsync(this.baseUrl + "api/Jobs/applications/search?" + searchQuery);
  }

  GetJobApplicationsByUserId(userId: number): Observable<any> {
    return this.http.GetAsync(this.baseUrl + "api/Jobs/applications/" + userId);
  }

  UpdateJobApplication(jobApplication: Jobapplication): Observable<any> {
    return this.http.PutAsync(this.baseUrl + "api/Jobs/applications/" + jobApplication.Id, jobApplication);
  }

  CreateQueryParamsForJobApplication(userId: number, jobId: number, cvSuitablityTypeId: number, candidateSelfSuitableTypeId: number
    , cvFeedbackTypeId: number, resumeId: number, coveringLetter: string, appliedOn: Date, isViewedByRecruiter: number,
    recruiterViewedOn: Date, candidateSelfNotes: string, employerSelfNotes: string, consultantNotes: string, isDeleted: number): string {

    var searchQuery = "";
    searchQuery += (userId !== undefined && userId != null && userId != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "userId=" : "&userId=") + userId : "";
    searchQuery += (jobId !== undefined && jobId != null && jobId != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "jobId=" : "&jobId=") + jobId : "";
    searchQuery += (cvSuitablityTypeId !== undefined && cvSuitablityTypeId != null && cvSuitablityTypeId != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "cvSuitablityTypeId=" : "&cvSuitablityTypeId=") + cvSuitablityTypeId : "";
    searchQuery += (candidateSelfSuitableTypeId !== undefined && candidateSelfSuitableTypeId != null && candidateSelfSuitableTypeId != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "candidateSelfSuitableTypeId=" : "&candidateSelfSuitableTypeId=") + candidateSelfSuitableTypeId : "";
    searchQuery += (cvFeedbackTypeId !== undefined && cvFeedbackTypeId != null && cvFeedbackTypeId != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "cvFeedbackTypeId=" : "&cvFeedbackTypeId=") + cvFeedbackTypeId : "";
    searchQuery += (resumeId !== undefined && resumeId != null && resumeId != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "resumeId=" : "&resumeId=") + resumeId : "";
    searchQuery += (coveringLetter !== undefined && coveringLetter != null && coveringLetter != "") ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "coveringLetter=" : "&coveringLetter=") + coveringLetter : "";
    searchQuery += (appliedOn !== undefined && appliedOn != null) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "appliedOn=" : "&appliedOn=") + appliedOn : "";
    searchQuery += (isViewedByRecruiter !== undefined && isViewedByRecruiter != null && isViewedByRecruiter != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "isViewedByRecruiter=" : "&isViewedByRecruiter=") + isViewedByRecruiter : "";
    searchQuery += (recruiterViewedOn !== undefined && recruiterViewedOn != null) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "recruiterViewedOn=" : "&recruiterViewedOn=") + recruiterViewedOn : "";
    searchQuery += (candidateSelfNotes !== undefined && candidateSelfNotes != null && candidateSelfNotes != "") ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "candidateSelfNotes=" : "&candidateSelfNotes=") + candidateSelfNotes : "";
    searchQuery += (employerSelfNotes !== undefined && employerSelfNotes != null && employerSelfNotes != "") ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "employerSelfNotes=" : "&employerSelfNotes=") + employerSelfNotes : "";
    searchQuery += (consultantNotes !== undefined && consultantNotes != null && consultantNotes != "") ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "consultantNotes=" : "&consultantNotes=") + consultantNotes : "";
    searchQuery += (isDeleted !== undefined && isDeleted != null && isDeleted != 0) ? ((searchQuery === undefined || searchQuery == null || searchQuery == "") ? "isDeleted=" : "&isDeleted=") + isDeleted : "";

    return searchQuery;
  }

  GetJobApplicationsStatus(userId: number, jobId: number, cvSuitablityTypeId: number, candidateSelfSuitableTypeId: number,
    cvFeedbackTypeId: number, resumeId: number, coveringLetter: string, appliedOn: Date, isViewedByRecruiter: number,
    recruiterViewedOn: Date, candidateSelfNotes: string, employerSelfNotes: string, consultantNotes: string, isDeleted: number): Observable<any> {

    let searchQuery = this.CreateQueryParamsForJobApplication(userId, jobId, cvSuitablityTypeId, candidateSelfSuitableTypeId, cvFeedbackTypeId,
      resumeId, coveringLetter, appliedOn, isViewedByRecruiter, recruiterViewedOn, candidateSelfNotes, employerSelfNotes, consultantNotes, isDeleted);


    return this.http.GetAsync(this.baseUrl + "api/Jobs/applyjobstatus?" + searchQuery);
  }

  CVDistributed(userId: number): Observable<number> {
    return this.http.GetAsync<number>(`${this.http.BaseUrl}api/affiliates/cvdistributed?userId=${userId}`);
  }

  QuickJobApplication(application: any): Observable<any> {
    return this.http.PostAsync<any>(this.baseUrl + "api/Jobs/applications/quickApply", application);
  }

  ApplyNow(job: Job): void {
    if (IsNull(job) || job?.IsApplied) {
      return;
    }

    if (job.Id == 0 || job.JobSourceId == JobSource.Appcast || job.JobSourceId == JobSource.AppCastPaid || job.JobSourceId == JobSource.AppcastPriority
      || job.JobSourceId == JobSource.ZipRecruiter || job.JobSourceId == JobSource.ZipRecruiterEnt || job.JobSourceId == JobSource.ZipRecruiterJB) {
      if (IsNotNullOrEmpty(job.ApplicationUrl)) {
        window.open(job.ApplicationUrl);
      }
    } else {
      if (IsNotNullOrEmpty(job.ApplicationUrl) && job.JobSourceId == JobSource.Broadbean) {
        window.open(job.ApplicationUrl, "_blank");
      } else {
        let url = this.GetApplyNowUrl(job);

        if (this.ContextService.IsUserLoggedIn || job.JobSourceId == JobSource.Barchester) {
          window.open(url);
        } else {
          this.ContextService.SignInRedirect(true, url, job.Id);
        }
      }
    }
  }

  GetApplyNowUrl(job: Job): string {
    let pipe = new JobApplyNowUrlPipe();
    let url = pipe.transform(job.Title, job.LocationText, job.Id, job.JobSourceId, job.ApplicationUrl);

    return url;
  }

  QuickApply(job: Job): void {
    if (IsNull(job) || IsZero(job?.Id) || job?.JobSourceId == JobSource.Barchester || job?.JobSourceId == JobSource.Appcast
      || job?.JobSourceId == JobSource.AppCastPaid || job?.JobSourceId == JobSource.AppcastPriority
      || job?.JobSourceId == JobSource.ZipRecruiter || job.JobSourceId == JobSource.ZipRecruiterEnt
      || job.JobSourceId == JobSource.ZipRecruiterJB) {
      return;
    }

    if (this.ContextService.IsUserLoggedIn) {
      if (job?.JobSourceId == JobSource.CvLibrary && this.IsCvDistributed == false) {
        return;
      }
    } else {
      this.localStorageService.SetItem(LoginTypeKeys.QuickApplyJobIdKey, job.Id.toString());
      this.ContextService.SignInRedirect(true, null, job.Id);
      return;
    }

    if (IsNotZero(this.QuickApplyJobId)) {
      this.QuickApplyJobId = 0;
    }

    let jobApplication = new Jobapplication();
    jobApplication.JobId = job.Id;
    jobApplication.UserId = this.ContextService.LoggedInUserId;

    this.loadingSerive.Show();

    this.GetJobApplicationsStatus(this.ContextService.LoggedInUserId, job.Id, null, null, null, null, null, null, null, null, null, null, null, 0).subscribe({
      next: statusId => {
        if (statusId == JobApplicationStatus.Success) {
          // call API to get user Resume
          this.profileService.getResumeByUserId(this.ContextService.LoggedInUserId).subscribe({
            next: resume => {
              if (IsAny(resume)) {
                let defaultResume = resume.filter(d => d.IsDefault);

                if (IsAny(defaultResume)) {
                  jobApplication.ResumeId = defaultResume[0].Id;
                } else {
                  jobApplication.ResumeId = resume[0].Id;
                }

                // If Quick Apply By Admin User

                if (IsNotZero(this.ContextService.GetA4UAdminUserId)) {
                  jobApplication.AppliedById = this.ContextService.GetA4UAdminUserId;
                } else {
                  jobApplication.AppliedById = null;
                }

                if (IsNotZero(jobApplication.ResumeId)) {
                  this.QuickJobApplication(jobApplication).subscribe({
                    next: reuslt => {
                      job.IsApplied = true;
                      this.loadingSerive.Hide();
                      this.toasterService.Success(Applynow.postJobApplicationAppliedMessage);
                    }, error: error => {
                      this.loadingSerive.Hide();
                      this.toasterService.ServerError();
                    }
                  });
                } else {
                  this.toasterService.Error(Applynow.QuickJobApplyNoResumeUploaded);
                }
              } else {
                this.loadingSerive.Hide();
                this.toasterService.Error(Applynow.QuickJobApplyNoResumeUploaded);
              }
            }, error: error => {
              this.loadingSerive.Hide();
              this.toasterService.ServerError();
            }
          });

        } else if (statusId == JobApplicationStatus.AlreadyApplied) {
          job.IsApplied = true;
          this.toasterService.Error(null, Applynow.onSubmitAppliedJobMessage);
          this.loadingSerive.Hide();
        } else if (statusId == JobApplicationStatus.JobStatusIsNotActive) {
          this.toasterService.Error(null, Applynow.postJobApplicationAppliedExpiredJob);
          this.loadingSerive.Hide();
        }
      },
      error: error => {
        this.loadingSerive.Hide();
      }
    });
  }

  GetQuickApplyJobId(): void {
    let quickApplyJobId = this.localStorageService.GetItem(LoginTypeKeys.QuickApplyJobIdKey);

    if (IsNotNullOrEmpty(quickApplyJobId)) {
      this.QuickApplyJobId = parseInt(quickApplyJobId);
      this.localStorageService.RemoveItem(LoginTypeKeys.QuickApplyJobIdKey);
    }
  }

  GetCvDistributionStatus(): void {
    if (this.ContextService.IsUserLoggedIn) {
      let status = this.localStorageService.GetItem(LoginTypeKeys.IsCvDistributed);

      if (IsNotNullOrEmpty(status)) {
        this.SetCVDistributionStatus(parseInt(status));
      } else {
        this.CVDistributed(this.ContextService.LoggedInUserId).subscribe({
          next: result => {
            this.SetCVDistributionStatus(result, true);
          }
        });
      }
    }
  }

  SetCVDistributionStatus(statusId: number, resetLocalStorage: boolean = false): void {
    this.CvDistributionStatusId = statusId;

    if (IsNotNull(statusId) && statusId == CvDistributionStatus.Duplicate || statusId == CvDistributionStatus.Success) {
      this.IsCvDistributed = true;
    } else {
      this.IsCvDistributed = false;
    }

    if (resetLocalStorage) {
      if (IsNotNull(statusId)) {
        this.localStorageService.SetItem(LoginTypeKeys.IsCvDistributed, statusId.toString());
      } else {
        this.ClearCVDistributionStatus();
      }
    }
  }

  ClearCVDistributionStatus(): void {
    this.localStorageService.RemoveItem(LoginTypeKeys.IsCvDistributed);
  }
}
